export type PresetDocument = {
  contractIds: number[];
  description: string;
  documentNumber: number;
  entityId: number;
  id: number;
  moduleDocumentNumber: string;
  name: string;
  screenId: string;
  values: unknown[];
  valuesLookup: unknown;
};
